import axios from "axios";
import * as yup from "yup";
import { buildQuery } from "utils/queryUtils";
import { formatDate } from "utils/date";

let schema = yup.object().shape({
    username: yup.string().test("not-blank", "username.required", (username) => username?.length > 0),
    fullName: yup.string().test("not-blank", "fullName.required", (fullName) => fullName?.length > 0),
});

export const validateUser = (user) => {
    return schema.validate(user, { abortEarly: false });
};

export const findUsers = (headers, params) => {
    let query = buildQuery(params, ["username", "fullName", "email"]);
    if (params.filters.phoneNumber.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value?.trim()}`;
    }
    if (params.filters.fromDate.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    if (params.filters.enabled.value !== null && params.filters.enabled.value !== undefined) {
        query += `&enabled=${params.filters.enabled.value ? 1 : 0}`;
    }
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.fullName.value) {
        query += `&fullName=${params.filters.fullName.value?.trim().toLowerCase()}`;
    }
    if (params.filters.type.value) {
        query += `&type=${params.filters.type.value?.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/users/search${query}`, {
        headers,
    });
};

export const countUsers = (headers, params) => {
    let query = buildQuery(params);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/users/count${query}`, {
        headers,
    });
};

export const createUser = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/users`, data, {
        headers,
    });
};

export const updateUser = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/users/${id}`, data, {
        headers,
    });
};

export const updateRoles = (headers, id, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/users/${id}/roles`, data, {
        headers,
    });
};
